import { FormConfiguration } from '@prisma/client'
import { useMemo } from 'react'
import { ConfigurationType, StepType } from '../../common/types'

type Props = {
  formConfiguration?: FormConfiguration
}

const STEP_DEFAULT: StepType = {
  key: 'default',
  inputs: [],
}

export const usePreparation = ({ formConfiguration }: Props) => {
  const configuration: ConfigurationType = useMemo(() => {
    const values: ConfigurationType =
      ((formConfiguration?.configuration as any) ?? {}) as ConfigurationType

    values.steps = values.steps ?? []

    if (values.steps.length === 0) {
      values.steps.push(STEP_DEFAULT)
    }

    return values
  }, [formConfiguration?.configuration, formConfiguration?.updatedAt])

  return configuration
}
